import React from 'react'
import { ErrorPageLayout } from 'react-angle-dashboard-components'

export const NotFound: React.FC = () => {
  return (
    <div style={{ marginTop: -75 }}>
      <ErrorPageLayout
        errorTitle="404 - Page not found"
        errorSubtitle="The page you were looking for could not be found."
      />
    </div>
  )
}

export default NotFound
